module.exports = __webpack_public_path__ + "static/TT1204_Header_Futures01a-3e50500b29b6c95f832493ef4f91476a.jpg";